import AccountMapActionTypes from './account-mapping.types';

/** ***************** GET ACCOUNT MAPPING DETAILS START *********************** */
export const getAccountMapDetailsStart = (getData: any) => ({
	type: AccountMapActionTypes.ACCOUNT_MAP_DETAILS_START,
	payload: getData,
});

export const getAccountMapDetailsSuccess = (successData: any) => ({
	type: AccountMapActionTypes.ACCOUNT_MAP_DETAILS_SUCCESS,
	payload: successData,
});

export const getAccountMapDetailsFailure = (failureData: any) => ({
	type: AccountMapActionTypes.ACCOUNT_MAP_DETAILS_FAILURE,
	payload: failureData,
});

export const getAccountMapDetailsResponseReset = () => ({
	type: AccountMapActionTypes.ACCOUNT_MAP_DETAILS_RESPONSE_RESET,
});

export const getAccountMapDetailsResponseChanged = () => ({
	type: AccountMapActionTypes.ACCOUNT_MAP_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ACCOUNT MAPPING DETAILS END *********************** */

/** ***************** UPDATE ACCOUNT MAPPING DETAILS START *********************** */
export const updateAccountMapDetailsStart = (postData: any) => ({
	type: AccountMapActionTypes.UPDATE_ACCOUNT_MAP_DETAILS_START,
	payload: postData,
});

export const updateAccountMapDetailsSuccess = (successData: any) => ({
	type: AccountMapActionTypes.UPDATE_ACCOUNT_MAP_DETAILS_SUCCESS,
	payload: successData,
});

export const updateAccountMapDetailsFailure = (failureData: any) => ({
	type: AccountMapActionTypes.UPDATE_ACCOUNT_MAP_DETAILS_FAILURE,
	payload: failureData,
});

export const updateAccountMapDetailsReset = () => ({
	type: AccountMapActionTypes.ACCOUNT_MAP_DETAILS_RESPONSE_RESET,
});

export const updateAccountMapDetailsResponseChanged = () => ({
	type: AccountMapActionTypes.UPDATE_ACCOUNT_MAP_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE ACCOUNT MAPPING DETAILS END *********************** */
